import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../../components/Button';
import { ReactComponent as DownloadIcon } from '../../icons/download.svg';

export default function FreshUserTodo() {
  const { t } = useTranslation();
  return (
    <div className='Paper pt-3 pb-4 ps-4 pe-3 mb-3'>
      <div className='SellerDashboard__gray d-flex justify-content-between align-items-center mb-3'>
        <div className='Text--sm text-uppercase '>{t('to do')}</div>
        <div className='Text--sm SellerDashboard__toDoBadge rounded px-1 text-uppercase'>
          {t('Until 6th of July')}
        </div>
      </div>
      <div className='mb-2 fw-300'>
        {t(
          'Always know what you need to do and when, and easily perform tasks right in the interface'
        )}
      </div>
      <div className='SellerDashboard__gray'>
        <div className='Text--30 fw-900 mb-2'>{t('Update EK price')}</div>
        <div className='mb-2'>
          {t('Please update the EK-price list and upload it back')}
        </div>
      </div>
      <Button
        className='SellerDashboard__toDoBtn px-3 py-2 d-inline-flex align-items-center'
        disabled
      >
        <DownloadIcon className='me-2' />
        {t('Download')}
      </Button>
    </div>
  );
}
